import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import Meta from '../../../components/Meta';
import { SUPPORT_EMAIL } from '../../../constants/constants';

const CatchReturn = () => {
  return (
    <>
    <Meta>
      title='配送・受取・返却方法について | ふるぷら'
      description='配送・受取・返却の方法について説明するページです。'
      keywords={['ふるぷら', '古着', 'レンタル', '受取', '返却']}
    </Meta>
    <Container className='my-5'>
      <Row className='justify-content-center'>
        <Col xs={12} md={8} lg={5}>
          <section className='catchreturntoppage'>
            <h1 className="fs-3 mb-4 text-center">配送・受取・返却方法について</h1>
              <h2 className='fs-5 fw-bold'>配送方法・送料</h2>
                <p>
                  配送方法：ご注文いただいた商品の在庫を持つ古着屋さんが発送作業を行います。<br />
                  商品受け取り時の送料：一律880円<br />
                  配送地域：日本全国<br />
                  発送日：発注から1営業日後以内に発送作業を行います。<br />
                  配送受取日時の指定：<br />
                  現在、ふるぷらのECサイト上では、配送日時指定ができません。<br />
                  お手数をおかけし、大変申し訳ございませんが、配送日時指定をご希望されるお客様は、<br />
                  <a
                      href={`mailto:${SUPPORT_EMAIL}`}
                      style={{ marginLeft: '0.5rem', color: '#0070f3' }}
                  >
                      {SUPPORT_EMAIL}
                  </a>
                  に希望する日時をご連絡ください。<br />
                  只今配送知事指定欄を準備中ですので、今しばらくお待ちください。<br />
                  お届け日：オーダー確定から1～3営業日後<br />
                </p>
              <h2 className='fs-5 fw-bold'>受取方法</h2>
                <p>
                  店舗受取または、郵送での受取が選択できます。<br />
                  店舗受取は、オーダー確定直後から商品を受け取ることができます。<br />
                  郵送での受取は送料がかかります。(一律880円)<br />
                </p>
              <h2 className='fs-5 fw-bold'>返却方法</h2>
                <p>
                  店舗返却または郵送返却を選択することができます。<br />
                  <br />
                  <span className='fs-6 fw-bold text-primary' >【店舗返却の方法】</span><br />
                  店舗返却の場合は、レンタルした商品の在庫をもつ古着屋さんに来店し、店員さんにレンタル商品返却の旨を伝えてください。<br />
                  店員さんに商品を渡したら、返却完了です。<br />
                  (※ふるぷらの加盟店マップはこちら：リンク)<br />
                  <br />
                  <span className='fs-6 fw-bold text-primary' >【郵送返却の方法】</span><br />
                  郵送による返却をされる場合は、返却予定日に間に合うように余裕をもって、発送の手続きを行ってください。<br />
                  <br />
                  商品の包装方法：丈夫な紙袋あるいは段ボール、レターパックに入れてください。破損の原因となります。<br />
                  配送業者：”宅急便”または”ゆうパック”をご選択ください。<br />
                  両業者は配送状況が追跡可能となっております。両業者以外の配送業者をご利用時に配送事故が発生した場合、お客様責任とみなし、紛失した場合と同様の追加料金をお支払いただくこととなります。ご了承ください。<br />
                  送料の支払方法：お客様負担となります。そのため、送料は”元払い”でお支払いください。<br />
                  配送先：レンタルした商品の在庫を持つ古着屋さんの所在地<br />
                  (※ふるぷらの加盟店マップはこちら：リンク)<br />
                  <br />
                  <div className='catchreturn-div'>
                    <h1 className='fs-5 fw-bold'>返却店舗の確認方法</h1>
                      <p>
                        1. ふるぷらECサイトのサイト上部にあるサイドバーの👤＞＞注文履歴を選択する。<br />
                        2．【返却期限が近い商品】の中から、返却したい商品の【確認する】をクリック。<br />
                        3．返却店舗と返却店舗の住所が表示。<br />
                      </p>
                  </div>
                <div className='return-notice'>
                  <h2 className='fs-5 fw-bold'>返却に関する注意点</h2>
                   <p>
                   <span className='fs-6 fw-bold text-danger' >重要なため、必ずご確認をお願いいたします。</span><br />
                      ・クリーニング・洗濯はお客様ご自身で絶対になさらないでください。<br />
                      ・汚れがついてしまった場合は、クリーニング・洗濯をせずにそのままご返却ください。<br />
                   </p>
                </div>
                </p>
          </section>
        </Col>
      </Row>
    </Container>
    </>
  )
}

export default CatchReturn